import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const navcanHomePlugin = createPlugin({
  id: 'navcan-home',
  routes: {
    root: rootRouteRef,
  },
});

export const NavCanHomePage = navcanHomePlugin.provide(
  createRoutableExtension({
    name: 'NavCanHomePage',
    component: () =>
      import('./components/LoggedInHomePage').then(m => m.LoggedInHomePage),
    mountPoint: rootRouteRef,
  }),
);
